import { postEvent } from "../../utils/helpers";

const Banner = (props) => {
    
    const navigateToUrl = () => {
        console.log(props.url);
        props.onClicked();
        window.open(props.url,'_blank');
    }

    return (
        <div onClick={navigateToUrl} style={{width: "88%", 
                            marginLeft: "auto", 
                            marginRight: "auto",
                            marginTop: "10px", 
                            }}>

            {props.imgSrc && <div>
                <span style={{
                    height: "12px",
                    width: "81px",
                    opacity: 0.5,
                    color: "#FFFFFF",
                    fontSize: "10px",
                    letterSpacing: "1.25px",
                    lineHeight: "11px"
                }}>Sponsored by</span>
                <img alt="Sponsor banner" src={props.imgSrc} style={{width: "100%"}}/> 
            </div>}
        </div>) 
}
export default Banner;